import { render, staticRenderFns } from "./TechInterventionView.vue?vue&type=template&id=4518e227"
import script from "./TechInterventionView.vue?vue&type=script&lang=js"
export * from "./TechInterventionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports